function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2048 2048",
    style: {
      enableBackground: "new 0 0 2048 2048"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_33_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A24BDB"
    },
    points: "1768,1381.15 1707.41,1407.01 1681.55,1467.6 1655.8,1407.01 1595.21,1381.15  1655.8,1355.4 1681.55,1294.81 1707.41,1355.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D20763"
    },
    d: "M450.19,320.1c28.11,0,51.02,22.91,51.02,51.02c0,27.99-22.91,50.9-51.02,50.9 c-27.99,0-50.9-22.91-50.9-50.9C399.29,343.01,422.2,320.1,450.19,320.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E4347"
    },
    d: "M1153.15,933.06v36.14c0,45.23-36.97,82.2-82.2,82.2c-22.62,0-43.17-9.24-58.07-24.14 c-14.89-14.9-24.13-35.44-24.13-58.06v-36.14c0-45.23,36.96-82.2,82.2-82.2C1116.18,850.86,1153.15,887.83,1153.15,933.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E4347"
    },
    d: "M763.52,933.06v36.14c0,45.23-37.08,82.2-82.2,82.2c-22.62,0-43.2-9.24-58.12-24.14 c-14.93-14.9-24.2-35.44-24.2-58.06v-36.14c0-45.23,37.09-82.2,82.32-82.2C726.44,850.86,763.52,887.83,763.52,933.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD93B"
    },
    d: "M991.23,392.73c318.52,0,576.7,357.62,576.7,676.03c0,318.53-258.18,576.71-576.7,576.71 c-318.41,0-576.59-258.18-576.59-576.71C414.64,750.35,672.82,392.73,991.23,392.73z M1153.15,969.2v-36.14 c0-45.23-36.97-82.2-82.2-82.2c-45.24,0-82.2,36.97-82.2,82.2v36.14c0,22.62,9.24,43.16,24.13,58.06 c14.9,14.9,35.45,24.14,58.07,24.14C1116.18,1051.4,1153.15,1014.43,1153.15,969.2z M763.52,969.2v-36.14 c0-45.23-37.08-82.2-82.2-82.2c-45.23,0-82.32,36.97-82.32,82.2v36.14c0,22.62,9.27,43.16,24.2,58.06 c14.92,14.9,35.5,24.14,58.12,24.14C726.44,1051.4,763.52,1014.43,763.52,969.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M991.23,1669.504c-81.067,0-159.724-15.886-233.786-47.217 c-71.524-30.258-135.755-73.568-190.909-128.729c-55.155-55.164-98.461-119.406-128.715-190.945 c-31.329-74.08-47.214-152.76-47.214-233.853c0-80.262,16.193-166.141,46.829-248.351 c30.064-80.677,74.118-158.193,127.398-224.168c56.051-69.405,120.064-124.463,190.262-163.644 c75.967-42.402,155.415-63.901,236.135-63.901c80.746,0,160.213,21.499,236.197,63.9 c70.212,39.18,134.236,94.238,190.295,163.644c53.287,65.973,97.346,143.489,127.412,224.168 c30.637,82.209,46.83,168.087,46.83,248.352c0,81.095-15.886,159.774-47.216,233.853 c-30.257,71.541-73.566,135.784-128.729,190.946c-55.161,55.162-119.403,98.473-190.942,128.729 C1151,1653.618,1072.322,1669.504,991.23,1669.504z M991.23,416.764c-141.654,0-279.804,74.465-389,209.678 C499.816,753.254,438.674,918.607,438.674,1068.76c0,304.746,247.875,552.676,552.556,552.676 c304.741,0,552.666-247.93,552.666-552.676c0-150.159-61.146-315.511-163.568-442.317 C1271.116,491.229,1132.932,416.764,991.23,416.764z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1343.322,750.057c-7.76,0-15.374-3.75-20.008-10.686 c-38.516-57.655-84.911-106.72-134.17-141.891c-10.803-7.713-13.308-22.723-5.595-33.526 c7.713-10.802,22.724-13.309,33.526-5.594c54.71,39.062,103.901,90.98,146.209,154.309c7.373,11.038,4.403,25.962-6.635,33.336 C1352.55,748.745,1347.91,750.057,1343.322,750.057z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M352.28,572.784c-13.274,0-24.034-10.76-24.034-24.034v-24.92 c0-13.274,10.76-24.034,24.034-24.034s24.034,10.76,24.034,24.034v24.92C376.314,562.024,365.554,572.784,352.28,572.784z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M424.44,620.144h-24.8c-13.274,0-24.034-10.76-24.034-24.034s10.76-24.034,24.034-24.034h24.8 c13.274,0,24.034,10.76,24.034,24.034S437.714,620.144,424.44,620.144z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M352.28,692.304c-13.274,0-24.034-10.76-24.034-24.034v-24.8 c0-13.274,10.76-24.034,24.034-24.034s24.034,10.76,24.034,24.034v24.8C376.314,681.544,365.554,692.304,352.28,692.304z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M304.92,620.144H280c-13.274,0-24.034-10.76-24.034-24.034s10.76-24.034,24.034-24.034h24.92 c13.274,0,24.034,10.76,24.034,24.034S318.194,620.144,304.92,620.144z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M450.19,446.054c-41.319,0-74.934-33.615-74.934-74.934c0-41.385,33.615-75.054,74.934-75.054 c41.385,0,75.054,33.669,75.054,75.054C525.244,412.439,491.575,446.054,450.19,446.054z M450.19,344.134 c-14.814,0-26.866,12.106-26.866,26.986c0,14.814,12.052,26.866,26.866,26.866c14.88,0,26.986-12.052,26.986-26.866 C477.176,356.24,465.07,344.134,450.19,344.134z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1681.55,1491.634c-0.006,0-0.012,0-0.019,0c-9.634-0.007-18.333-5.767-22.101-14.634 l-21.966-51.684l-51.689-22.061c-8.86-3.782-14.607-12.489-14.6-22.124c0.007-9.634,5.767-18.333,14.634-22.101l51.664-21.957 l21.956-51.665c3.769-8.867,12.468-14.626,22.102-14.634c0.006,0,0.013,0,0.019,0c9.628,0,18.325,5.744,22.105,14.6 l22.062,51.69l51.684,21.966c8.867,3.768,14.627,12.467,14.634,22.101c0.008,9.635-5.739,18.342-14.6,22.124l-51.71,22.069 l-22.069,51.709C1699.876,1485.889,1691.177,1491.634,1681.55,1491.634z M1656.548,1381.197l8.687,3.707 c5.711,2.438,10.257,6.99,12.685,12.705l3.678,8.653l3.708-8.688c2.433-5.699,6.972-10.238,12.671-12.671l8.687-3.707 l-8.652-3.678c-5.715-2.428-10.268-6.974-12.705-12.685l-3.708-8.688l-3.677,8.653c-2.434,5.727-6.993,10.285-12.72,12.719 L1656.548,1381.197z M1655.8,1355.4h0.01H1655.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1481.95,1632.294c-13.273,0-24.034-10.761-24.034-24.034v-24.8 c0-13.273,10.761-24.034,24.034-24.034s24.034,10.761,24.034,24.034v24.8C1505.984,1621.533,1495.224,1632.294,1481.95,1632.294 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1554.11,1679.774h-24.801c-13.273,0-24.034-10.761-24.034-24.034s10.761-24.034,24.034-24.034 h24.801c13.273,0,24.034,10.761,24.034,24.034S1567.384,1679.774,1554.11,1679.774z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1481.95,1751.935c-13.273,0-24.034-10.761-24.034-24.034V1703.1 c0-13.273,10.761-24.034,24.034-24.034s24.034,10.761,24.034,24.034v24.801 C1505.984,1741.174,1495.224,1751.935,1481.95,1751.935z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1434.47,1679.774h-24.8c-13.273,0-24.034-10.761-24.034-24.034s10.761-24.034,24.034-24.034 h24.8c13.273,0,24.034,10.761,24.034,24.034S1447.743,1679.774,1434.47,1679.774z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1115.71,1279.634H636.56c-13.274,0-24.034-10.761-24.034-24.034s10.76-24.034,24.034-24.034 h479.15c13.273,0,24.034,10.761,24.034,24.034S1128.983,1279.634,1115.71,1279.634z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M681.32,1075.435c-28.305,0-54.978-11.069-75.104-31.169c-20.15-20.109-31.25-46.77-31.25-75.065 v-36.14c0-58.578,47.71-106.234,106.354-106.234c58.578,0,106.234,47.656,106.234,106.234v36.14 C787.554,1027.778,739.897,1075.435,681.32,1075.435z M681.32,874.894c-32.139,0-58.286,26.093-58.286,58.166v36.14 c0,15.437,6.088,30.015,17.144,41.047c11.056,11.042,25.665,17.119,41.142,17.119c32.073,0,58.166-26.093,58.166-58.166v-36.14 C739.486,900.987,713.393,874.894,681.32,874.894z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1070.95,1075.435c-28.3,0-54.958-11.073-75.065-31.18 c-20.102-20.116-31.169-46.769-31.169-75.055v-36.14c0-58.578,47.656-106.234,106.234-106.234s106.234,47.656,106.234,106.234 v36.14C1177.185,1027.778,1129.528,1075.435,1070.95,1075.435z M1070.95,874.894c-32.072,0-58.166,26.093-58.166,58.166v36.14 c0,15.453,6.072,30.039,17.097,41.071c11.021,11.022,25.609,17.095,41.069,17.095c32.072,0,58.166-26.093,58.166-58.166v-36.14 C1129.116,900.987,1103.022,874.894,1070.95,874.894z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.3015239f9cc44552a453b1cc4990ffcd.svg";
export { ForwardRef as ReactComponent };